export default [
    {
        path: '/admin-vip/tiendas/99/metricas',
        name: 'admin-vip.metricas',
        component: () => import(/* webpackChunkName: "informacion" */ '../../pages/metricas').then(m => m.default || m),
    }
]
